(function () {
  smoothScroll(document.querySelectorAll('.js-scroll'))

  function smoothScroll(scrollTrigger) {
    scrollTrigger.forEach(function(trigger) {
      trigger.addEventListener('click', (e) => {
        if(targetNav)if(targetNav.classList.contains('is-show'))menuClose()
        e.preventDefault();
        let href = trigger.getAttribute('href');
        let targetElement = document.getElementById(href.replace('#', ''));
        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.scrollY;
        const gap = 0;
        const target = rect + offset - gap;
        window.scrollTo({
          top: target,
          behavior: 'smooth',
        })
      })
    });
  }
}());